// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/bgTry4.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Hero.css */
 
/* ── Background image ── */
header.hero.hero-fullscreen {
  min-height: 100vh;
  display: flex;
  align-items: center;
  position: relative;
  background-color: var(--slate);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: #eaf0f6;
  overflow: visible;
}
 
/* ── Overlay ── */
.hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(rgba(15, 24, 34, 0.42), rgba(15, 24, 34, 0.58));
  z-index: 1;
}
 
/* ── Layout principal ── */
.hero-layout {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  padding: 40px 0;
}
 
.hero-content-wrapper {
  display: flex;
  align-items: center;
  gap: 50px;
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0 60px;
}
 
.hero-text-section {
  flex: 1 1;
  text-align: left;
  min-width: 0;
  max-width: 52%;
}
 
.hero-map-section {
  flex: 0 0 48%;
  max-width: 48%;
}
 
/* ── Map container ── */
.hero-map-section .map-preview-wrapper {
  width: 100% !important;
  height: 520px !important;
  margin: 0 !important;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 0 40px rgba(225, 6, 19, 0.15), 0 16px 48px rgba(0, 0, 0, 0.5);
}
 
/* ── Eyebrow ── */
.hero-eyebrow {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  color: #fff;
  margin-bottom: 16px;
  font-size: 18px;
  line-height: 1.4;
  text-align: left;
  width: 100%;
}
 
.hero-eyebrow span {
  font-weight: 700;
  opacity: 0.9;
}
 
.hero-eyebrow strong {
  font-weight: 700;
}
 
/* ── Titre ── */
.hero-text-section h1 {
  font-size: 48px;
  font-weight: 800;
  line-height: 1.1;
  color: #fff;
  margin: 0 0 20px;
  text-shadow: 0 4px 18px rgba(0, 0, 0, 0.5);
}
 
.hero-text-section h1 .u {
  color: #e8341a;
  font-style: italic;
}
 
/* ── Texte description ── */
.hero-sub-box {
  margin: 0 0 24px 0;
  max-width: 100%;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
 
.hero-sub-box p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: #ddeeff;
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.5);
}
 
/* ── CTA ── */
.hero-text-section .cta {
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 28px;
  flex-wrap: wrap;
}
 
.hero-text-section .cta .btn {
  padding: 14px 28px;
  font-size: 15px;
  border-radius: 10px;
  box-sizing: border-box;
  border: none;
  line-height: 1.2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  cursor: pointer;
  margin: 0;
}
/* ── Stats en bas ── */
.hero-stats {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 35px;
  margin-top: 32px;
  padding: 16px 0 0 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}
 
.hero-stat-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  padding: 0;
  flex: 0 0 150px;
  width: 150px;
  gap: 2px;
}
 
.hero-stat-icon {
  font-size: 18px;
  color: #e8341a;
  margin-bottom: 3px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
 
.hero-stat-label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.08em;
  color: #aac4b0;
  text-transform: uppercase;
  margin-bottom: 2px;
}
 
.hero-stat-value-wrapper {
  display: flex;
  align-items: baseline;
  gap: 4px;
  flex-wrap: wrap;
}
 
.hero-stat-pre {
  font-size: 10px;
  font-weight: 500;
  color: #aac4b0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
 
.hero-stat-value {
  font-size: 24px;
  font-weight: 800;
  color: #e8341a;
  line-height: 1.1;
}
 
.hero-stat-unit {
  font-size: 14px;
  font-weight: 700;
  color: #e8341a;
  letter-spacing: 0.06em;
}
 
.hero-stat-note {
  font-size: 14px;
  color: #7a9e88;
  line-height: 1.3;
  margin-top: 2px;
  max-width: 190px;
}
 
/* ── Compense la hauteur de la nav en position: fixed ── */
.hero {
  padding-top: 56px;
}
 
@media (max-width: 880px) {
  .hero {
    padding-top: 100px; /* nav passe sur 2 lignes : logo/texte + liens en dessous */
  }
}
 
@media (max-width: 600px) {
  .hero {
    padding-top: 90px; /* nav 2 lignes, polices/paddings réduits */
  }
}
 
@media (max-width: 430px) {
  .hero {
    padding-top: 130px;
  }
}
 
@media (max-width: 360px) {
  .hero {
    padding-top: 118px;
  }
}
 
 
/* ── Responsive ── */
/* ── Laptop / Desktop : réduire globalement (~90% du rendu actuel) ── */
@media (max-width: 1500px) {
  .hero-layout {
    min-height: 90vh;
    padding: 20px 0;
  }
 
  .hero-content-wrapper {
    padding: 0 34px;
    gap: 32px;
    align-items: center;
  }
 
  .hero-text-section {
    max-width: 50%;
  }
 
  .hero-map-section {
    flex: 0 0 44%;
    max-width: 44%;
  }
 
  .hero-text-section h1 {
    font-size: 36px;
    line-height: 1.08;
    margin-bottom: 16px;
  }
 
  .hero-eyebrow {
    font-size: 15px;
    margin-bottom: 12px;
  }
 
  .hero-sub-box {
    gap: 6px;
    margin-bottom: 18px;
  }
 
  .hero-sub-box p {
    font-size: 13px;
    line-height: 1.45;
  }
 
  .hero-text-section .cta .btn {
    padding: 12px 22px;
    font-size: 14px;
  }
 
  .hero-map-section .map-preview-wrapper {
    height: 410px !important;
    border-radius: 14px;
  }
 
  .hero-stats {
    margin-top: 24px;
    padding-top: 14px;
    gap: 18px;
  }
 
  .hero-stat-item {
    gap: 0;
  }
 
  .hero-stat-icon {
    font-size: 14px;
  }
 
  .hero-stat-label {
    font-size: 8px;
  }
 
  .hero-stat-value {
    font-size: 18px;
  }
 
  .hero-stat-unit {
    font-size: 11px;
  }
 
  .hero-stat-note {
    font-size: 11px;
    line-height: 1.25;
  }
}
 
/* ── Desktop classique (1000 → 1280) ── */
@media (max-width: 1280px) {
  .hero-content-wrapper {
    padding: 0 26px;
    gap: 28px;
  }
 
  .hero-text-section h1 {
    font-size: 32px;
  }
 
  .hero-eyebrow {
    font-size: 14px;
  }
 
  .hero-sub-box p {
    font-size: 12.5px;
  }
 
  .hero-map-section .map-preview-wrapper {
    height: 360px !important;
  }
 
  .hero-stats {
    gap: 14px;
  }
 
  .hero-stat-value {
    font-size: 16px;
  }
 
  .hero-stat-note {
    font-size: 10px;
  }
}
 
@media (max-width: 1024px) {
  .hero-content-wrapper {
    flex-direction: column;
    align-items: center;
    gap: 30px;
    padding: 0 24px;
  }
 
  .hero-text-section {
    max-width: 100%;
    width: 100%;
    text-align: center;
  }
 
  .hero-eyebrow {
    align-items: center;
    text-align: center;
  }
 
  .hero-sub-box {
    text-align: center;
  }
 
  .hero-text-section .cta {
    display: flex;
    justify-content: center;
  }
 
  .hero-map-section {
    flex: 0 0 100%;
    max-width: 100%;
    width: 100%;
    margin-top: 12px;
  }
 
  .hero-map-section .map-preview-wrapper {
    height: 420px !important;
  }
 
  .hero-stats {
    gap: 16px;
    flex-wrap: nowrap;
    justify-content: center;
  }
 
  .hero-stat-item {
    flex: 0 0 130px;
    width: 130px;
    align-items: center;
    text-align: center;
  }
 
  .hero-stat-icon {
    font-size: 15px;
    justify-content: center;
  }
 
  .hero-stat-label {
    font-size: 9px;
  }
 
  .hero-stat-value {
    font-size: 18px;
  }
 
  .hero-stat-unit {
    font-size: 11px;
  }
 
  .hero-stat-note {
    font-size: 11px;
    max-width: 100%;
  }
}
 
@media (max-width: 768px) {
  .hero-content-wrapper {
    padding: 0 16px;
    gap: 24px;
  }
 
  .hero-text-section h1 {
    font-size: 32px;
  }
 
  .hero-sub-box {
    text-align: center;
  }
 
  .hero-sub-box p {
    font-size: 13px;
  }
 
  .hero-map-section .map-preview-wrapper {
    height: 340px !important;
  }
 
  .hero-stats {
    gap: 16px;
    flex-wrap: wrap;
    justify-content: center;
  }
 
  .hero-stat-item {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 12px);
    align-items: center;
    text-align: center;
  }
 
  .hero-stat-icon {
    justify-content: center;
  }
}
 
@media (max-width: 480px) {
  .hero-content-wrapper {
    padding: 0 12px;
    align-items: center;
  }
 
  .hero-text-section {
    text-align: center;
  }
 
  .hero-eyebrow {
    font-size: 14px;
    align-items: center;
    text-align: center;
  }
 
  .hero-text-section h1 {
    font-size: 26px;
  }
 
  .hero-sub-box {
    text-align: center;
  }
 
  .hero-text-section .cta {
    display: flex;
    justify-content: center;
  }
 
  .hero-stats {
    justify-content: center;
  }
 
  .hero-stat-item {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 6px);
    align-items: center;
    text-align: center;
  }
 
  .hero-stat-icon {
    justify-content: center;
  }
 
  .hero-stat-note {
    max-width: 100%;
  }
 
  .hero-map-section .map-preview-wrapper {
    height: 280px !important;
  }
 
  .hero-stats {
    gap: 12px;
  }
}
 
@media (max-width: 360px) {
  .hero-content-wrapper {
    padding: 0 10px;
  }
 
  .hero-eyebrow {
    font-size: 12.5px;
    line-height: 1.35;
    text-align: center;
  }
 
  .hero-text-section h1 {
    font-size: 22px;
  }
 
  .hero-sub-box p {
    font-size: 12px;
  }
 
  .hero-stat-item {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 6px);
  }
}
 
/* ── Écrans larges type "gaming" ET suffisamment hauts (≥1850px
   largeur, hauteur > 1361px) : agrandissement complet, sans risque
   de débordement vertical du Hero ── */
@media (min-width: 1850px) and (min-height: 1362px) {
  .hero-content-wrapper {
    max-width: 2400px;
    margin: 0 auto;
    gap: 90px;
    padding: 0 100px;
  }
 
  .hero-eyebrow {
    font-size: 22px;
  }
 
  .hero-text-section h1 {
    font-size: 68px;
  }
 
  .hero-sub-box {
    gap: 10px;
  }
 
  .hero-sub-box p {
    font-size: 19px;
  }
 
  .hero-text-section .cta .btn {
    padding: 20px 40px;
    font-size: 19px;
  }
 
  .hero-map-section .map-preview-wrapper {
    height: 600px !important;
  }
 
  .hero-stats {
    max-width: 880px;
    gap: 48px;
    margin-top: 44px;
    padding-top: 20px;
  }
 
  .hero-stat-icon {
    font-size: 24px;
  }
 
  .hero-stat-label {
    font-size: 13px;
  }
 
  .hero-stat-value {
    font-size: 34px;
  }
 
  .hero-stat-unit {
    font-size: 19px;
  }
 
  .hero-stat-note {
    font-size: 17px;
    max-width: 260px;
  }
}
 
/* ── Écrans larges type "gaming" mais hauteur limitée
   (ex: 2850×1361px) : exploite la largeur disponible avec un
   agrandissement modéré, pour ne jamais dépasser la hauteur
   d'écran disponible ── */
@media (min-width: 1850px) and (max-height: 1361px) {
  .hero-layout {
    min-height: 100vh;
    padding: 16px 0;
  }
 
  .hero-content-wrapper {
    max-width: 2200px;
    margin: 0 auto;
    gap: 70px;
    padding: 0 90px;
  }
 
  .hero-eyebrow {
    font-size: 18px;
    margin-bottom: 12px;
  }
 
  .hero-text-section h1 {
    font-size: 46px;
    line-height: 1.1;
    margin-bottom: 14px;
  }
 
  .hero-sub-box {
    gap: 7px;
    margin-bottom: 16px;
  }
 
  .hero-sub-box p {
    font-size: 15px;
    line-height: 1.4;
  }
 
  .hero-text-section .cta .btn {
    padding: 14px 28px;
    font-size: 16px;
  }
 
  .hero-map-section .map-preview-wrapper {
    height: 460px !important;
  }
 
  .hero-stats {
    max-width: 760px;
    gap: 32px;
    margin-top: 24px;
    padding-top: 14px;
  }
 
  .hero-stat-icon {
    font-size: 17px;
  }
 
  .hero-stat-label {
    font-size: 10px;
  }
 
  .hero-stat-value {
    font-size: 22px;
  }
 
  .hero-stat-unit {
    font-size: 13px;
  }
 
  .hero-stat-note {
    font-size: 12px;
    max-width: 200px;
  }
}
 
/* ── Bouton retour en haut ── */
.scroll-to-top {
  position: fixed;
  bottom: 32px;
  right: 32px;
  z-index: 999;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  background: #EE5B43;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(238, 91, 67, 0.45);
  opacity: 0;
  transform: translateY(12px);
  pointer-events: none;
  transition: opacity 0.25s ease, transform 0.25s ease, background 0.2s ease;
}
 
.scroll-to-top--visible {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}
 
.scroll-to-top:hover {
  background: #d6432c;
  box-shadow: 0 6px 20px rgba(238, 91, 67, 0.55);
}
 
.scroll-to-top svg {
  font-size: 24px;
}
 
@media (max-width: 480px) {
  .scroll-to-top {
    bottom: 20px;
    right: 20px;
    width: 42px;
    height: 42px;
  }
 
  .scroll-to-top svg {
    font-size: 20px;
  }
}
@supports (padding-top: env(safe-area-inset-top)) {
  @media (max-width: 480px) {
    .hero-layout {
      padding-top: calc(50px + env(safe-area-inset-top));
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/Hero/Hero.css"],"names":[],"mappings":"AAAA,aAAa;;AAEb,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,yDAA6D;EAC7D,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,cAAc;EACd,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,QAAQ;EACR,2EAA2E;EAC3E,UAAU;AACZ;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,sBAAsB;EACtB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,2EAA2E;AAC7E;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;;AAEA,cAAc;AACd;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;AACA,uBAAuB;AACvB;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA,2DAA2D;AAC3D;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,kBAAkB,EAAE,2DAA2D;EACjF;AACF;;AAEA;EACE;IACE,iBAAiB,EAAE,2CAA2C;EAChE;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;;AAGA,qBAAqB;AACrB,wEAAwE;AACxE;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,MAAM;EACR;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA,0CAA0C;AAC1C;EACE;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,SAAS;IACT,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,SAAS;IACT,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;EAC3B;AACF;;AAEA;;uCAEuC;AACvC;EACE;IACE,iBAAiB;IACjB,cAAc;IACd,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;;;0BAG0B;AAC1B;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,8CAA8C;EAC9C,UAAU;EACV,2BAA2B;EAC3B,oBAAoB;EACpB,0EAA0E;AAC5E;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE;MACE,kDAAkD;IACpD;EACF;AACF","sourcesContent":["/* Hero.css */\n \n/* ── Background image ── */\nheader.hero.hero-fullscreen {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  position: relative;\n  background-color: var(--slate);\n  background-image: url(\"../../../../public/images/bgTry4.png\");\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  color: #eaf0f6;\n  overflow: visible;\n}\n \n/* ── Overlay ── */\n.hero-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(rgba(15, 24, 34, 0.42), rgba(15, 24, 34, 0.58));\n  z-index: 1;\n}\n \n/* ── Layout principal ── */\n.hero-layout {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  min-height: 100vh;\n  padding: 40px 0;\n}\n \n.hero-content-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 50px;\n  width: 100%;\n  max-width: 100%;\n  margin: 0;\n  padding: 0 60px;\n}\n \n.hero-text-section {\n  flex: 1;\n  text-align: left;\n  min-width: 0;\n  max-width: 52%;\n}\n \n.hero-map-section {\n  flex: 0 0 48%;\n  max-width: 48%;\n}\n \n/* ── Map container ── */\n.hero-map-section .map-preview-wrapper {\n  width: 100% !important;\n  height: 520px !important;\n  margin: 0 !important;\n  border-radius: 16px;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 0 40px rgba(225, 6, 19, 0.15), 0 16px 48px rgba(0, 0, 0, 0.5);\n}\n \n/* ── Eyebrow ── */\n.hero-eyebrow {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  color: #fff;\n  margin-bottom: 16px;\n  font-size: 18px;\n  line-height: 1.4;\n  text-align: left;\n  width: 100%;\n}\n \n.hero-eyebrow span {\n  font-weight: 700;\n  opacity: 0.9;\n}\n \n.hero-eyebrow strong {\n  font-weight: 700;\n}\n \n/* ── Titre ── */\n.hero-text-section h1 {\n  font-size: 48px;\n  font-weight: 800;\n  line-height: 1.1;\n  color: #fff;\n  margin: 0 0 20px;\n  text-shadow: 0 4px 18px rgba(0, 0, 0, 0.5);\n}\n \n.hero-text-section h1 .u {\n  color: #e8341a;\n  font-style: italic;\n}\n \n/* ── Texte description ── */\n.hero-sub-box {\n  margin: 0 0 24px 0;\n  max-width: 100%;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n \n.hero-sub-box p {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #ddeeff;\n  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.5);\n}\n \n/* ── CTA ── */\n.hero-text-section .cta {\n  margin-top: 4px;\n  display: flex;\n  align-items: center;\n  gap: 28px;\n  flex-wrap: wrap;\n}\n \n.hero-text-section .cta .btn {\n  padding: 14px 28px;\n  font-size: 15px;\n  border-radius: 10px;\n  box-sizing: border-box;\n  border: none;\n  line-height: 1.2;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  cursor: pointer;\n  margin: 0;\n}\n/* ── Stats en bas ── */\n.hero-stats {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 35px;\n  margin-top: 32px;\n  padding: 16px 0 0 0;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n \n.hero-stat-item {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  text-align: left;\n  padding: 0;\n  flex: 0 0 150px;\n  width: 150px;\n  gap: 2px;\n}\n \n.hero-stat-icon {\n  font-size: 18px;\n  color: #e8341a;\n  margin-bottom: 3px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n \n.hero-stat-label {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  color: #aac4b0;\n  text-transform: uppercase;\n  margin-bottom: 2px;\n}\n \n.hero-stat-value-wrapper {\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n \n.hero-stat-pre {\n  font-size: 10px;\n  font-weight: 500;\n  color: #aac4b0;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n \n.hero-stat-value {\n  font-size: 24px;\n  font-weight: 800;\n  color: #e8341a;\n  line-height: 1.1;\n}\n \n.hero-stat-unit {\n  font-size: 14px;\n  font-weight: 700;\n  color: #e8341a;\n  letter-spacing: 0.06em;\n}\n \n.hero-stat-note {\n  font-size: 14px;\n  color: #7a9e88;\n  line-height: 1.3;\n  margin-top: 2px;\n  max-width: 190px;\n}\n \n/* ── Compense la hauteur de la nav en position: fixed ── */\n.hero {\n  padding-top: 56px;\n}\n \n@media (max-width: 880px) {\n  .hero {\n    padding-top: 100px; /* nav passe sur 2 lignes : logo/texte + liens en dessous */\n  }\n}\n \n@media (max-width: 600px) {\n  .hero {\n    padding-top: 90px; /* nav 2 lignes, polices/paddings réduits */\n  }\n}\n \n@media (max-width: 430px) {\n  .hero {\n    padding-top: 130px;\n  }\n}\n \n@media (max-width: 360px) {\n  .hero {\n    padding-top: 118px;\n  }\n}\n \n \n/* ── Responsive ── */\n/* ── Laptop / Desktop : réduire globalement (~90% du rendu actuel) ── */\n@media (max-width: 1500px) {\n  .hero-layout {\n    min-height: 90vh;\n    padding: 20px 0;\n  }\n \n  .hero-content-wrapper {\n    padding: 0 34px;\n    gap: 32px;\n    align-items: center;\n  }\n \n  .hero-text-section {\n    max-width: 50%;\n  }\n \n  .hero-map-section {\n    flex: 0 0 44%;\n    max-width: 44%;\n  }\n \n  .hero-text-section h1 {\n    font-size: 36px;\n    line-height: 1.08;\n    margin-bottom: 16px;\n  }\n \n  .hero-eyebrow {\n    font-size: 15px;\n    margin-bottom: 12px;\n  }\n \n  .hero-sub-box {\n    gap: 6px;\n    margin-bottom: 18px;\n  }\n \n  .hero-sub-box p {\n    font-size: 13px;\n    line-height: 1.45;\n  }\n \n  .hero-text-section .cta .btn {\n    padding: 12px 22px;\n    font-size: 14px;\n  }\n \n  .hero-map-section .map-preview-wrapper {\n    height: 410px !important;\n    border-radius: 14px;\n  }\n \n  .hero-stats {\n    margin-top: 24px;\n    padding-top: 14px;\n    gap: 18px;\n  }\n \n  .hero-stat-item {\n    gap: 0;\n  }\n \n  .hero-stat-icon {\n    font-size: 14px;\n  }\n \n  .hero-stat-label {\n    font-size: 8px;\n  }\n \n  .hero-stat-value {\n    font-size: 18px;\n  }\n \n  .hero-stat-unit {\n    font-size: 11px;\n  }\n \n  .hero-stat-note {\n    font-size: 11px;\n    line-height: 1.25;\n  }\n}\n \n/* ── Desktop classique (1000 → 1280) ── */\n@media (max-width: 1280px) {\n  .hero-content-wrapper {\n    padding: 0 26px;\n    gap: 28px;\n  }\n \n  .hero-text-section h1 {\n    font-size: 32px;\n  }\n \n  .hero-eyebrow {\n    font-size: 14px;\n  }\n \n  .hero-sub-box p {\n    font-size: 12.5px;\n  }\n \n  .hero-map-section .map-preview-wrapper {\n    height: 360px !important;\n  }\n \n  .hero-stats {\n    gap: 14px;\n  }\n \n  .hero-stat-value {\n    font-size: 16px;\n  }\n \n  .hero-stat-note {\n    font-size: 10px;\n  }\n}\n \n@media (max-width: 1024px) {\n  .hero-content-wrapper {\n    flex-direction: column;\n    align-items: center;\n    gap: 30px;\n    padding: 0 24px;\n  }\n \n  .hero-text-section {\n    max-width: 100%;\n    width: 100%;\n    text-align: center;\n  }\n \n  .hero-eyebrow {\n    align-items: center;\n    text-align: center;\n  }\n \n  .hero-sub-box {\n    text-align: center;\n  }\n \n  .hero-text-section .cta {\n    display: flex;\n    justify-content: center;\n  }\n \n  .hero-map-section {\n    flex: 0 0 100%;\n    max-width: 100%;\n    width: 100%;\n    margin-top: 12px;\n  }\n \n  .hero-map-section .map-preview-wrapper {\n    height: 420px !important;\n  }\n \n  .hero-stats {\n    gap: 16px;\n    flex-wrap: nowrap;\n    justify-content: center;\n  }\n \n  .hero-stat-item {\n    flex: 0 0 130px;\n    width: 130px;\n    align-items: center;\n    text-align: center;\n  }\n \n  .hero-stat-icon {\n    font-size: 15px;\n    justify-content: center;\n  }\n \n  .hero-stat-label {\n    font-size: 9px;\n  }\n \n  .hero-stat-value {\n    font-size: 18px;\n  }\n \n  .hero-stat-unit {\n    font-size: 11px;\n  }\n \n  .hero-stat-note {\n    font-size: 11px;\n    max-width: 100%;\n  }\n}\n \n@media (max-width: 768px) {\n  .hero-content-wrapper {\n    padding: 0 16px;\n    gap: 24px;\n  }\n \n  .hero-text-section h1 {\n    font-size: 32px;\n  }\n \n  .hero-sub-box {\n    text-align: center;\n  }\n \n  .hero-sub-box p {\n    font-size: 13px;\n  }\n \n  .hero-map-section .map-preview-wrapper {\n    height: 340px !important;\n  }\n \n  .hero-stats {\n    gap: 16px;\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n \n  .hero-stat-item {\n    flex: 0 0 calc(50% - 12px);\n    align-items: center;\n    text-align: center;\n  }\n \n  .hero-stat-icon {\n    justify-content: center;\n  }\n}\n \n@media (max-width: 480px) {\n  .hero-content-wrapper {\n    padding: 0 12px;\n    align-items: center;\n  }\n \n  .hero-text-section {\n    text-align: center;\n  }\n \n  .hero-eyebrow {\n    font-size: 14px;\n    align-items: center;\n    text-align: center;\n  }\n \n  .hero-text-section h1 {\n    font-size: 26px;\n  }\n \n  .hero-sub-box {\n    text-align: center;\n  }\n \n  .hero-text-section .cta {\n    display: flex;\n    justify-content: center;\n  }\n \n  .hero-stats {\n    justify-content: center;\n  }\n \n  .hero-stat-item {\n    flex: 0 0 calc(50% - 6px);\n    align-items: center;\n    text-align: center;\n  }\n \n  .hero-stat-icon {\n    justify-content: center;\n  }\n \n  .hero-stat-note {\n    max-width: 100%;\n  }\n \n  .hero-map-section .map-preview-wrapper {\n    height: 280px !important;\n  }\n \n  .hero-stats {\n    gap: 12px;\n  }\n}\n \n@media (max-width: 360px) {\n  .hero-content-wrapper {\n    padding: 0 10px;\n  }\n \n  .hero-eyebrow {\n    font-size: 12.5px;\n    line-height: 1.35;\n    text-align: center;\n  }\n \n  .hero-text-section h1 {\n    font-size: 22px;\n  }\n \n  .hero-sub-box p {\n    font-size: 12px;\n  }\n \n  .hero-stat-item {\n    flex: 0 0 calc(50% - 6px);\n  }\n}\n \n/* ── Écrans larges type \"gaming\" ET suffisamment hauts (≥1850px\n   largeur, hauteur > 1361px) : agrandissement complet, sans risque\n   de débordement vertical du Hero ── */\n@media (min-width: 1850px) and (min-height: 1362px) {\n  .hero-content-wrapper {\n    max-width: 2400px;\n    margin: 0 auto;\n    gap: 90px;\n    padding: 0 100px;\n  }\n \n  .hero-eyebrow {\n    font-size: 22px;\n  }\n \n  .hero-text-section h1 {\n    font-size: 68px;\n  }\n \n  .hero-sub-box {\n    gap: 10px;\n  }\n \n  .hero-sub-box p {\n    font-size: 19px;\n  }\n \n  .hero-text-section .cta .btn {\n    padding: 20px 40px;\n    font-size: 19px;\n  }\n \n  .hero-map-section .map-preview-wrapper {\n    height: 600px !important;\n  }\n \n  .hero-stats {\n    max-width: 880px;\n    gap: 48px;\n    margin-top: 44px;\n    padding-top: 20px;\n  }\n \n  .hero-stat-icon {\n    font-size: 24px;\n  }\n \n  .hero-stat-label {\n    font-size: 13px;\n  }\n \n  .hero-stat-value {\n    font-size: 34px;\n  }\n \n  .hero-stat-unit {\n    font-size: 19px;\n  }\n \n  .hero-stat-note {\n    font-size: 17px;\n    max-width: 260px;\n  }\n}\n \n/* ── Écrans larges type \"gaming\" mais hauteur limitée\n   (ex: 2850×1361px) : exploite la largeur disponible avec un\n   agrandissement modéré, pour ne jamais dépasser la hauteur\n   d'écran disponible ── */\n@media (min-width: 1850px) and (max-height: 1361px) {\n  .hero-layout {\n    min-height: 100vh;\n    padding: 16px 0;\n  }\n \n  .hero-content-wrapper {\n    max-width: 2200px;\n    margin: 0 auto;\n    gap: 70px;\n    padding: 0 90px;\n  }\n \n  .hero-eyebrow {\n    font-size: 18px;\n    margin-bottom: 12px;\n  }\n \n  .hero-text-section h1 {\n    font-size: 46px;\n    line-height: 1.1;\n    margin-bottom: 14px;\n  }\n \n  .hero-sub-box {\n    gap: 7px;\n    margin-bottom: 16px;\n  }\n \n  .hero-sub-box p {\n    font-size: 15px;\n    line-height: 1.4;\n  }\n \n  .hero-text-section .cta .btn {\n    padding: 14px 28px;\n    font-size: 16px;\n  }\n \n  .hero-map-section .map-preview-wrapper {\n    height: 460px !important;\n  }\n \n  .hero-stats {\n    max-width: 760px;\n    gap: 32px;\n    margin-top: 24px;\n    padding-top: 14px;\n  }\n \n  .hero-stat-icon {\n    font-size: 17px;\n  }\n \n  .hero-stat-label {\n    font-size: 10px;\n  }\n \n  .hero-stat-value {\n    font-size: 22px;\n  }\n \n  .hero-stat-unit {\n    font-size: 13px;\n  }\n \n  .hero-stat-note {\n    font-size: 12px;\n    max-width: 200px;\n  }\n}\n \n/* ── Bouton retour en haut ── */\n.scroll-to-top {\n  position: fixed;\n  bottom: 32px;\n  right: 32px;\n  z-index: 999;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  border: none;\n  background: #EE5B43;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0 4px 16px rgba(238, 91, 67, 0.45);\n  opacity: 0;\n  transform: translateY(12px);\n  pointer-events: none;\n  transition: opacity 0.25s ease, transform 0.25s ease, background 0.2s ease;\n}\n \n.scroll-to-top--visible {\n  opacity: 1;\n  transform: translateY(0);\n  pointer-events: auto;\n}\n \n.scroll-to-top:hover {\n  background: #d6432c;\n  box-shadow: 0 6px 20px rgba(238, 91, 67, 0.55);\n}\n \n.scroll-to-top svg {\n  font-size: 24px;\n}\n \n@media (max-width: 480px) {\n  .scroll-to-top {\n    bottom: 20px;\n    right: 20px;\n    width: 42px;\n    height: 42px;\n  }\n \n  .scroll-to-top svg {\n    font-size: 20px;\n  }\n}\n@supports (padding-top: env(safe-area-inset-top)) {\n  @media (max-width: 480px) {\n    .hero-layout {\n      padding-top: calc(50px + env(safe-area-inset-top));\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
